export default "__VITE_ASSET__2bcf6479__"